<div class="page-container" animate.enter="route-slide-in-right" animate.leave="route-slide-out-right">
  <div class="page-title-row flex flex-align-center gap-sm mb-md">
    <app-back-button [ariaLabel]="'settings.back' | translate" />
    <h2>{{ 'settings.connection.title' | translate }}</h2>
  </div>

  <app-card>
    <app-card-content>
      <div class="setting-item">
        <div class="setting-header">
          <h4>{{ 'settings.stayOffline.title' | translate }}</h4>
          <app-checkbox [(ngModel)]="stayOfflineModeValue" (ngModelChange)="toggleStayOfflineMode()"
            data-testid="stay-offline-toggle" />
        </div>
        <p class="setting-description">
          {{ 'settings.stayOffline.description' | translate }}
        </p>
      </div>

      @if (stayOfflineMode() && isOnline()) {
      <div class="manual-sync-section">
        <app-button variant="outlined" (click)="triggerManualSync()" [disabled]="syncingManually() || syncSuccess()"
          data-testid="manual-sync-button">
          @if (syncSuccess()) {
          <app-icon name="circle-check-big" />
          <span>{{ 'settings.manualSync.success' | translate }}</span>
          } @else {
          <app-icon name="refresh-cw" [class.spinning]="syncingManually()" />
          @if (syncingManually()) {
          <span>{{ 'settings.manualSync.updating' | translate }}</span>
          } @else {
          <span>{{ 'settings.manualSync.button' | translate }}</span>
          }
          }
        </app-button>

        @if (syncError()) {
        <div class="error-message">
          <div class="error-content">
            <app-icon name="circle-alert" />
            <span>{{ syncError() }}</span>
          </div>
          <button class="dismiss-button" (click)="dismissSyncError()"
            [attr.aria-label]="'settings.manualSync.dismiss' | translate">
            <app-icon name="x" />
          </button>
        </div>
        }

        @if (syncSuccess()) {
        <div class="success-message">
          <app-icon name="circle-check-big" />
          <span>{{ 'settings.sync.successMessage' | translate }}</span>
        </div>
        }
      </div>
      }

      <div class="status-chips">
        <app-chip [color]="isOnline() ? 'success' : 'danger'">
          {{ 'settings.status.network' | translate:{ status: (isOnline() ? ('settings.status.networkOnline' |
          translate) : ('settings.status.networkOffline' | translate)) } }}
        </app-chip>
        <app-chip [color]="syncConnected() ? 'success' : 'primary'">
          {{ 'settings.status.server' | translate:{ status: (syncConnected() ? ('settings.status.serverConnected' |
          translate) : ('settings.status.serverDisconnected' | translate)) } }}
        </app-chip>
      </div>
    </app-card-content>
  </app-card>
</div>
